import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dcb574f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-edition-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "user-edition-page__title" }, "Редактирование данных врача", -1))
const _hoisted_3 = { class: "user-edition-page__form-content" }
const _hoisted_4 = { class: "user-edition-page__form-content-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Имя")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Должность")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Эл. адрес")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Token")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Обновить ")
const _hoisted_10 = { class: "user-edition-page__form-submit" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Сохранить данные ")

import { computed, onMounted, reactive, ref } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { UserEditType, OrganizationType } from '@/shared/types'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { organizationsApi, usersApi, userApi } from '@/shared/api'
import { COMMON_RULES, POSSIBLE_TOKEN_CHARS } from '@/shared/constants'
import { showErrorMessage } from '@/shared/utils'

enum InputNames {
  NAME = 'name',
  POSITION = 'position',
  EMAIL = 'email',
  ROLE = 'role',
  ORGANIZATION = 'organization',
  TOKEN = 'token',
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const loading = ref(false)
const loadingOrganzations = ref(false)
const userEditionForm = ref<FormInstance>()

const formInputs = reactive({
  name: undefined,
  position: undefined,
  email: undefined,
  role: undefined,
  organization: undefined,
  token: undefined,
})

const userEditionFormData: UserEditType = reactive({
  id: undefined,
  name: '',
  position: '',
  email: '',
  role: '',
  organizations: [],
  token: '',
})

const userEditionValidationRules = reactive<FormRules>({
  name: [COMMON_RULES.nameRequired],
  position: [COMMON_RULES.positionRequired],
  email: [COMMON_RULES.emailRequired, COMMON_RULES.emailIncorrect],
  role: [COMMON_RULES.roleRequired],
  organizations: [COMMON_RULES.organizationsRequired],
})

const organizations = ref<OrganizationType[]>([])

const userId = computed((): string | string[] => route.params.userId)

const getUserInfo = async (): Promise<void> => {
  loading.value = true

  const [error, response] = await userApi.getUser(Number(userId.value))

  if (error) {
    showErrorMessage(error)
  } else {
    const user = response.data.user

    userEditionFormData.id = user.id
    userEditionFormData.name = user.name
    userEditionFormData.position = user.position
    userEditionFormData.email = user.email
    userEditionFormData.role = user.role
    userEditionFormData.token = user.api_token

    userEditionFormData.organizations = user.organization.map(
      (organization) => organization.id
    )
  }

  loading.value = false
}

const getOrganizations = async (query: string): Promise<void> => {
  loadingOrganzations.value = true

  const [error, response] = await organizationsApi.getOrganizations(query, 50)

  if (error) {
    showErrorMessage(error)
  } else {
    organizations.value = response.data.organizations
  }

  loadingOrganzations.value = false
}

const generateToken = (): void => {
  userEditionFormData.token = ''

  for (let i = 0; i < 30; i++) {
    userEditionFormData.token += POSSIBLE_TOKEN_CHARS.charAt(
      Math.floor(Math.random() * POSSIBLE_TOKEN_CHARS.length)
    )
  }
}

const editUser = async (): Promise<boolean> => {
  const [error] = await usersApi.updateUser(userEditionFormData)

  if (error) {
    showErrorMessage(error)

    return false
  }

  ElMessage({
    message: 'Данные обновлены',
    type: 'success',
  })

  return true
}

const handleChangeFocusedInput = (nextInput: string): void => {
  formInputs[nextInput].focus()
}

const handleSubmitForm = (form: FormInstance | undefined): void => {
  if (!form) return

  form.validate(async (valid): Promise<boolean> => {
    if (valid) {
      const isUserEdited = await editUser()

      if (isUserEdited) {
        router.push({
          name: 'UsersShowPage',
          params: {
            userId: userId.value,
            organizationId: userEditionFormData.organizations[0],
          },
        })
      }
    }

    return false
  })
}

onMounted(async (): Promise<void> => {
  await getOrganizations('')
  getUserInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, {
      ref_key: "userEditionForm",
      ref: userEditionForm,
      model: _unref(userEditionFormData),
      rules: _unref(userEditionValidationRules),
      class: "user-edition-page__form"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "name",
                      class: "user-edition-page__form-item",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (handleChangeFocusedInput(InputNames.POSITION)), ["enter"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref: "name",
                          modelValue: _unref(userEditionFormData).name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userEditionFormData).name) = $event))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "position",
                      class: "user-edition-page__form-item",
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (handleChangeFocusedInput(InputNames.EMAIL)), ["enter"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref: "position",
                          modelValue: _unref(userEditionFormData).position,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userEditionFormData).position) = $event))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "email",
                      class: "user-edition-page__form-item",
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (handleChangeFocusedInput(InputNames.ROLE)), ["enter"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref: "email",
                          modelValue: _unref(userEditionFormData).email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userEditionFormData).email) = $event))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "role",
                      class: "user-edition-page__form-item",
                      onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (handleChangeFocusedInput(InputNames.ORGANIZATION)), ["enter"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          ref: "role",
                          modelValue: _unref(userEditionFormData).role,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(userEditionFormData).role) = $event)),
                          placeholder: "Роль"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Доктор",
                              value: "doktor"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Главный врач",
                              value: "head_doctor"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Администратор",
                              value: "admin"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "organizations",
                      class: "user-edition-page__form-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          ref: "organization",
                          modelValue: _unref(userEditionFormData).organizations,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(userEditionFormData).organizations) = $event)),
                          filterable: "",
                          remote: "",
                          "remote-show-suffix": "",
                          "remote-method": getOrganizations,
                          loading: loadingOrganzations.value,
                          multiple: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          placeholder: "Клиника"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: organization.name,
                                value: organization.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "token",
                      class: "user-edition-page__form-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref: "token",
                          modelValue: _unref(userEditionFormData).token,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(userEditionFormData).token) = $event))
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 13 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "user-edition-page__form-button",
                          type: "primary",
                          round: "",
                          onClick: generateToken
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            class: "user-edition-page__form-button",
            type: "primary",
            round: "",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (handleSubmitForm(userEditionForm.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { body: true }
    ]
  ])
}
}

})